export function sendWebPushNotification(title, body) {
  if (!("Notification" in window) || Notification.permission !== "granted") {
    console.warn("[WebPush] Notifications désactivées ou refusées");
    return;
  }
  navigator.serviceWorker.ready.then((registration) => {
    registration.showNotification(title, {
      body,
      icon: "/Aifel.svg",
    });
  });
}
